import * as jwt from 'jwt-decode';

export type DecodedUser = {
  id: number;
  name: string;
  email: string;
  role: string;
  exp: number;
  iat: number;
};


export function getLoggedInUser(): DecodedUser | null {
  const token = localStorage.getItem('token');
  if (!token) return null;

  try {
    return jwt.jwtDecode<DecodedUser>(token);
  } catch (err) {
    console.error('Invalid token:', err);
    return null;
  }
}
